export default function Spinner() {
  return (
    <div style={{ margin: "8%" }}>
      <div className="d-flex justify-content-center ">
        <div className="spinner-border spinner" role="status"></div>
      </div>
      <div
        style={{ marginTop: "1.5%" }}
        className="d-flex justify-content-center"
      >
        <p style={{ fontStyle: "oblique" }}>Loading...</p>
      </div>
    </div>
  );
}
